<div class="flex flex-1 flex-row gap-5">
	<form #tenancyForm="ngForm" (ngSubmit)="onSubmit(tenancyForm)" class="w-1/2">
		<h2>Current rental period</h2>

		<app-input
			label="Adjustment title"
			[(ngModel)]="adjustment.title"
			class="mt-5"
			placeholder="TENANCY"
			name="title"
		></app-input>

		<app-radio-group
			class="mt-3"
			[items]="areaItems"
			label="Area occupied"
			name="area"
			[(ngModel)]="adjustment.area"
			(ngModelChange)="changed()"
			type="compact"
		></app-radio-group>
		<app-input
			type="text"
			*ngIf="adjustment.area === 'specify'"
			label="Description of area occupied"
			name="areaDescription"
			class="mt-3"
			[(ngModel)]="adjustment.areaDescription"
			(ngModelChange)="changed()"
		></app-input>
		<app-input
			type="cents"
			label="Rent amount"
			name="rent"
			class="mt-3"
			[startIcon]="ICON.DOLLAR"
			[(ngModel)]="adjustment.rent"
			(ngModelChange)="changed()"
		></app-input>
		<div class="mt-3">
			<app-checkbox
				label="Apply HST ({{ hst | percent }})"
				[(ngModel)]="adjustment.applyHst"
				(ngModelChange)="changed()"
				name="applyHST"
			></app-checkbox>
		</div>
		<app-date-picker
			label="Start date of current rental period"
			name="rentalStart"
			class="mt-3"
			[(ngModel)]="adjustment.rentalStart"
			(ngModelChange)="changed()"
			[required]="true"
			[submitted]="submitted"
			maxDate="{{ maxStartDate }}"
			maxDateErrorLabel="{{ maxStartDateLabel }}"
		></app-date-picker>
		<app-date-picker
			label="End date of current rental period"
			name="rentalEnd"
			class="mt-3"
			[(ngModel)]="adjustment.rentalEnd"
			(ngModelChange)="changed()"
			[required]="true"
			[submitted]="submitted"
			minDate="{{ adjustment.rentalStart }}"
			minDateErrorLabel="the Start Date"
		></app-date-picker>
		<app-radio-group
			class="mt-3"
			[items]="vendorCollectedItems"
			label="Vendor has collected rent for above rental period"
			name="format"
			[(ngModel)]="adjustment.vendorCollected"
			(ngModelChange)="changed()"
			type="compact"
		></app-radio-group>
		<app-input
			*ngIf="vendorDays && adjustment.vendorCollected === 'yes'"
			type="cents"
			label="Vendor's share for {{ vendorDays }} days"
			name="credit"
			class="mt-3"
			[startIcon]="ICON.DOLLAR"
			[ngModel]="vendorShare"
			[disabled]="true"
		></app-input>
		<app-input
			*ngIf="creditAmount >= 0"
			type="cents"
			label="Credit vendor"
			name="credit"
			class="mt-3"
			[startIcon]="ICON.DOLLAR"
			[ngModel]="creditAmount"
			[disabled]="true"
		></app-input>
		<app-input
			*ngIf="creditAmount < 0"
			type="cents"
			label="Credit purchaser"
			name="credit"
			class="mt-3"
			[startIcon]="ICON.DOLLAR"
			[ngModel]="creditAmount * -1"
			[disabled]="true"
		></app-input>
		<div class="mt-3">
			<app-checkbox
				label="Include all details in document"
				[(ngModel)]="adjustment.details"
				name="includeAllDetails"
			></app-checkbox>
		</div>

		<div class="flex justify-between mr-5 mt-5">
			<app-button btn="tertiary" class="mr-5" (click)="cancelModal()"
				>Cancel</app-button
			>
			<app-button type="submit">Save</app-button>
		</div>
	</form>
	<div class="w-1/2">
		<app-container type="dark" title="Details">
			<div class="flex flex-1 flex-col">
				<div class="mb-8">
					<div class="flex justify-between items-start mb-3">
						<div>Rent amount</div>
						<div>{{ adjustment.rent | centsToDollars }}</div>
					</div>
					<ng-container *ngIf="adjustment.vendorCollected === 'yes'">
						<div class="flex justify-between items-start mb-3">
							<div>
								Vendor has collected rent for period commencing on
								{{ adjustment.rentalStart | date: 'longDate' }}
							</div>
						</div>
						<div class="flex justify-between items-start mb-3">
							<div>Vendor's share for {{ vendorDays }} days</div>
							<div>{{ vendorShare | centsToDollars }}</div>
						</div>
					</ng-container>
					<ng-container *ngIf="adjustment.vendorCollected === 'no'">
						<div class="flex justify-between items-start mb-3">
							<div>
								Purchaser to collect rent for period commencing on
								{{ adjustment.rentalStart | date }}
							</div>
						</div>
						<div class="flex justify-between items-start mb-3">
							<div>Purchaser's share for {{ vendorDays }} days</div>
							<div>{{ vendorShare | centsToDollars }}</div>
						</div>
					</ng-container>
					<div
						*ngIf="adjustment.applyHst"
						class="flex justify-end items-start mb-8"
					>
						<div>
							<strong
								>HST ({{ hst | percent }}) =
								{{ hstAmount | centsToDollars }}</strong
							>
						</div>
					</div>
					<div class="flex justify-end items-start">
						<div *ngIf="creditAmount >= 0">
							<strong
								>Credit Vendor = {{ creditAmount | centsToDollars }}</strong
							>
						</div>
						<div *ngIf="creditAmount < 0">
							<strong
								>Credit Purchaser =
								{{ creditAmount * -1 | centsToDollars }}</strong
							>
						</div>
					</div>
				</div>
			</div>
		</app-container>
	</div>
</div>
